module.exports = __webpack_public_path__ + "static/media/order_down_Gray.00fe69a8.svg";